{
  "version": 1,
  "asset_id": "6d790ce4-c208-4ce7-8d25-6f642ed28b81",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/6d790ce4-c208-4ce7-8d25-6f642ed28b81/avcilar-hizli-elektrikci-7-24-dukkan-2.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/6d790ce4-c208-4ce7-8d25-6f642ed28b81/avcilar-hizli-elektrikci-7-24-dukkan-2.jpg",
  "original_filename": "avcilar-hizli-elektrikci-7-24-dukkan-2.jpg",
  "size": 584807,
  "content_type": "image/jpeg",
  "created_at": "2026-09-11T13:23:30Z"
}
